import React from 'react';
import Konva from 'konva';
import { isUndefined } from 'lodash';
import useEventListener from 'hooks/use-event-listener';
import { Position } from 'types';

interface UseNodeDragAnimation {
  animateOnDragMove(event: any, currentPointerPosition: Position): void;
  animateOnDragEnd(): void;
}

export default function useNodeDragAnimation(): UseNodeDragAnimation {
  const tweenRef = React.useRef<Konva.Tween | undefined>();

  const startPointerPositionPositionRef = React.useRef<Position | undefined>();

  useEventListener(
    'mousedown',
    (event) => {
      startPointerPositionPositionRef.current = {
        x: event.pageX,
        y: event.pageY,
      };
    },
    document,
  );

  function animateOnDragMove(event, currentPointerPosition) {
    if (isUndefined(tweenRef.current)) {
      const startPointerPositionPosition =
        startPointerPositionPositionRef.current;

      let rotation = -5;

      if (currentPointerPosition && startPointerPositionPosition) {
        const xDiff = currentPointerPosition.x - startPointerPositionPosition.x;
        const yDiff = currentPointerPosition.y - startPointerPositionPosition.y;
        if ((xDiff < 0 && yDiff < 0) || (xDiff >= 0 && yDiff >= 0)) {
          rotation = 5;
        }
      }

      tweenRef.current = new Konva.Tween({
        node: event.target,
        duration: 0.075,
        rotation,
        scaleX: 1.05,
        scaleY: 1.05,
      });
    }

    tweenRef.current?.play();
  }

  function animateOnDragEnd() {
    tweenRef.current?.reverse();
    tweenRef.current = undefined;
  }

  return { animateOnDragEnd, animateOnDragMove };
}
